import { Config } from 'modules/config/state/config-types'
import { URLParams } from 'modules/url-params/state/app-url-params-types'
import { OrderDesignationSlice } from './order-designation-types'

export const DEFAULT_DESIGNATION_ID = -1
export const DEFAULT_DESIGNATION_NAME = ''

export const makeOrderDesignationInitialState = (
  config: Config,
  urlParams: URLParams,
): OrderDesignationSlice => {
  let designationId = urlParams.designation

  if (!designationId) {
    designationId = config.designation.designationId
  }

  const designationName = DEFAULT_DESIGNATION_NAME

  return {
    value: {
      designationId,
      designationName,
    },
  }
}
